import React, { Component } from 'react'
import '../styles/MarketChainStudy.css'
import OrgFooter from '../widgets/OrgFooter'
import DropdownWidget from '../widgets/DropdownWidget'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'
import APISiteRequest from '../api/APISiteRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import APISupplyPlanRequest from '../api/APISupplyPlanRequest'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'

class SupplyPlan extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			clusterId: sessionStorage.getItem("cluster-id"),
			siteId: JSON.parse(localStorage.getItem("siteId")),
			spid: props.spid,
			scrollable: false,
			mop: "-- SELECT --",
			buyer: "-- SELECT --",
			unit: "-- SELECT --",
			frequency: "DOES NOT REPEAT",
			frequencyId: 1,
			repeatEvery: 0,
			unitPrice: 0.0,
			disabled: props.disabled,
			pbid: props.pbid,
			itemObjTB: {},
			buyers: [],
			targetBuyers: {},
			deleteTargetBuyers: {},
			itemObjCL: {},
			clusters: [],
			clusterNames: {},
			deleteClusterNames: {},
			collectiveMarketing: {},
			deleteCollectiveMarketing: {},
			overlayHeight: "100%",
			title: "ADD",
			totalVolume: 0,
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.getAllCrops = this.getAllCrops.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.eventHandlerCL = this.eventHandlerCL.bind(this)
		this.setClusterNames = this.setClusterNames.bind(this)
		this.setScrollable = this.setScrollable.bind(this)
		this.onResize = this.onResize.bind(this)
		this.getAllClustersBySiteId = this.getAllClustersBySiteId.bind(this)
		this.getAllClustersBySiteIdAndCropId = this.getAllClustersBySiteIdAndCropId.bind(this)
		this.getAllUnitsOfMeasurement = this.getAllUnitsOfMeasurement.bind(this)
		this.getSupplyPlanById = this.getSupplyPlanById.bind(this)
		this.addSupplyPlan = this.addSupplyPlan.bind(this)
		this.editSupplyPlan = this.editSupplyPlan.bind(this)
		this.onMarketingButtonClicked = this.onMarketingButtonClicked.bind(this)
		this.getAllProspectiveBuyersBySiteId = this.getAllProspectiveBuyersBySiteId.bind(this)
		this.addClusterInvolvement = this.addClusterInvolvement.bind(this)
		this.getTotalVolumeCommited = this.getTotalVolumeCommited.bind(this)
		this.getFarmerCommitmentsByClusterInvolvementId = this.getFarmerCommitmentsByClusterInvolvementId.bind(this)
		this.getProspectiveBuyersBySiteIdAndCropId = this.getProspectiveBuyersBySiteIdAndCropId.bind(this)
	}

	onSubmit(frm, clusterId, targetCropId, clusterDD) { // parameter for encode commitments
		console.log('onSubmit', frm, clusterId, targetCropId, clusterDD)
		this.setState({showActivityIndicator: true})
		if(this.state.cropId == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Target crop is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.unit == null || this.state.unit == '-- SELECT --') {
			this.setState({
				showWarningMessage: true,
				aMessage: "Unit of measurement is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.startDate == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Start date is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.endDate == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "End date is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.buyer == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Name of Buyer is required",
				showActivityIndicator: false
			})
			return
		}
		const targetBuyers = []
		const addTargetBuyers = []
		if(this.state.targetMarketId == null) {
			addTargetBuyers.push(this.state.targetBuyer)
		}
		else {
			targetBuyers.push(this.state.targetBuyer)
		}
		const clusterNames = []
		const addClusterNames = []
		Object.values(this.state.clusterNames).forEach((v => {
			if(v.sp_involved_cluster_id == null) {
				addClusterNames.push(v)
			}
			else {
				clusterNames.push(v)
			}
		}))
		const deleteClusterNames = []
		Object.values(this.state.deleteClusterNames).forEach((v => {
			deleteClusterNames.push(v)  
		}))
		const spData = {}
		spData["supplyPlan"] = {
			site_id: this.state.siteId,
			crop_id: this.state.cropId,
			target_volume: this.state.volume,
			unit_of_measurement: this.state.unit,
			start_date: this.state.startDate,
			end_date: this.state.endDate,
		}
		if(this.state.spid != null) {
			if(targetBuyers.length > 0) {
				spData["targetMarket"] = targetBuyers
			}
			if(addTargetBuyers.length > 0) {
				spData["add"] = {}
				spData["add"]["targetMarket"] = addTargetBuyers
			}
			if(clusterNames.length > 0) {
				spData["involvedCluster"] = clusterNames
			}
			if(addClusterNames.length > 0) {
				if(spData["add"] == null) {
					spData["add"] = {}
				}
				spData["add"]["involvedCluster"] = addClusterNames
			}
			if(deleteClusterNames.length > 0) {
				if(spData["delete"]) {
					spData["delete"] = {}
				}
				spData["delete"]["involvedCluster"] = deleteClusterNames
			}
		}
		else {
			if(addClusterNames.length > 0) {
				spData["involvedCluster"] = addClusterNames
			}
			if(addTargetBuyers.length > 0) {
				spData["targetMarket"] = addTargetBuyers
			}
		}
		if(this.state.spid == null) {
			this.addSupplyPlan(frm, clusterId, spData, clusterDD)
		}
		else {
			this.editSupplyPlan(frm, clusterId, spData, targetCropId, clusterDD)

		}
	}

	addSupplyPlan(frm, clusterId, data, targetCropId, clusterDD) {
		const apiReq = APISupplyPlanRequest.addSupplyPlan(this.state.accessToken, data)
		apiReq.then((response) => {
			console.log('addSupplyPlan', response)
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(frm != null && clusterId != null) {
				this.props.setView(frm, clusterId, clusterDD?.name, response.results.supply_plan_id, targetCropId, clusterDD?.deliveryDate)
				return
			}
			this.setClusterNames(null, this.state.disabled, this.state.clusterList, response.results.supply_plan_id)
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	editSupplyPlan(frm, clusterId, data, targetCropId, clusterDD) {
		console.log('editSupplyPlanById', clusterDD)
		const apiReq = APISupplyPlanRequest.editSupplyPlanById(this.state.accessToken, data, this.state.spid)
		apiReq.then((response) => {
			console.log('editSupplyPlanById', response, clusterDD)
			if(response.status !== "SUCCESS") {
				this.setState({
					showActivityIndicator: false
				})
				return
			}
			if(frm === "encode-commitments" && clusterId != null) {
				if(response.errors[3]?.addInvolvedCluster.length > 0) {
					this.setState({
						showWarningMessage: true,
						aMessage: 'Duplicate entry for cluster and initial commitment date.',
						showActivityIndicator: false
					})
					return
				}
				let tci = targetCropId
				if(tci == null) {
					this.state.clusterList.map((item, i) => {
						if(item.id == clusterId) {
							tci = item.targetCropId
						}
					})
				}
				this.props.setView(frm, clusterId, clusterDD.name, this.state.spid, tci, clusterDD.deliveryDate, response.results.added.involvedCluster[0].id)
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	addClusterInvolvement() {
		if(this.state.involvedCluster == null) {
			return
		}
		const ciData = {
			supplyPlan: this.state.supplyPlan,
			targetMarket: this.state.targetMarket,
			add: {
				involvedCluster: this.state.involvedClusters
			}
		}
	}

	handleFooterEvent(e) {
		if(e === "UPDATE") {
			this.setClusterNames(null, false)
			this.setState({disabled: false, title: "UPDATE"})
		}
		else {
			// this.props.handleFooterEvent(e)
		}
	}

	componentWillMount() {
		if(this.state.spid !=  null) {
			this.getSupplyPlanById((ics, tms, cropId, crop) => {
				this.getProspectiveBuyersBySiteIdAndCropId(cropId)
				this.getAllClustersBySiteIdAndCropId((clusterList) => {
					this.getTotalVolumeCommited(ics)
					this.setClusterNames(ics, this.state.disabled, clusterList, cropId)
				}, cropId)
			})
		}
		else {
			this.getAllClustersBySiteIdAndCropId((clusterList) => {
				this.setClusterNames(null, this.state.disabled, clusterList)
			})
		}
		// this.getAllProspectiveBuyersBySiteId()
		// this.getProspectiveBuyersBySiteIdAndCropId()
		this.getAllCrops()
		this.getAllUnitsOfMeasurement()
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	getTotalVolumeCommited(ics) {
		ics.map((item, i) => {
			this.getFarmerCommitmentsByClusterInvolvementId(item.sp_involvement_id)
		})
	}

	getFarmerCommitmentsByClusterInvolvementId(spiid) {
		const apiReq = APISupplyPlanRequest.getFarmerCommitmentsByClusterInvolvementId(this.state.accessToken, spiid)
		apiReq.then((response) => {
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			let evalSupply = this.state.totalVolume
			for(const v of response.results.farmerCommitment) {
				evalSupply += v.evaluated_supply
			}
			this.setState({totalVolume: evalSupply})
			const data = {
				supplyPlan: {
					"target_volume": evalSupply
				}
			}
			const apiReq = APISupplyPlanRequest.editSupplyPlanById(this.state.accessToken, data, this.state.spid)
			apiReq.then((response) => {
				console.log('editSupplyPlanById ', response)
			})
		})
	}

	getSupplyPlanById(callback) {
		const req = APISupplyPlanRequest.getSupplyPlanById(this.state.accessToken, this.state.spid)
		req.then((response) => {
			console.log('getSupplyPlanById', response)
			if(response.status === "FAILED") {
				return
			}
			const involvedCluster = response.results.involvedCluster.slice(0)
			involvedCluster.sort((a, b) => {
				return a.sp_involvement_id - b.sp_involvement_id
			})
			callback(involvedCluster, response.results.targetMarket, response.results.supplyPlan.crop_id, response.results.supplyPlan.crop)
			this.setState({
				showActivityIndicator: false,
				targetCrop: response.results.supplyPlan.crop,
				cropId: response.results.supplyPlan.crop_id,
				targetVolume: response.results.supplyPlan.target_volume,
				unit: response.results.supplyPlan.unit_of_measurement,
				startDate: response.results.supplyPlan.start_date,
				endDate: response.results.supplyPlan.end_date,
				buyer: response.results.supplyPlan.target_market_name,
				targetMarketId: response.results.supplyPlan.mcs_prospective_buyer_id,
				supplyPlan: response.results.supplyPlan,
				targetMarket: response.results.targetMarket,
			})
		})
	}

	getAllClustersBySiteIdAndCropId(callback, cropId) {
		const clusters = APIClusterRequest.getAllClustersBySiteIdAndCropId(this.state.accessToken, this.state.siteId, cropId)
		clusters.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const rows = {}
			for(const v of response.results.rows) {
				rows[v.cluster_id] = ({id: v.cluster_id, name: v.cluster_name.toUpperCase(), targetCropId: v.target_crop_id})
			}
			const r = Object.values(rows)
			callback(r)
			this.setState({clusterList: r})
		})
	}

	getAllClustersBySiteId(callback, crop) {
		const clusters = APIClusterRequest.getAllClustersBySiteId(this.state.accessToken, this.state.siteId)
		clusters.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const rows = {}
			for(const v of response.results.rows) {
				if(v.crop === crop) {
					rows[v.cluster_id] = ({id: v.cluster_id, name: v.cluster_name.toUpperCase(), targetCropId: v.target_crop_id})
				}
			}
			const r = Object.values(rows)
			callback(r)
			this.setState({clusterList: r})
		})
	}

	getAllProspectiveBuyersBySiteId(callBack) {
		const apiReq = APISiteRequest.getAllProspectiveBuyersBySiteId(this.state.accessToken, this.state.siteId)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const rows = []
			for(const v of response.results) {
				rows.push({id: v.mcs_prospective_buyer_id, name: v.target_market_name})
			}
			this.setState({registeredBuyers: rows})
		})
	}

	getProspectiveBuyersBySiteIdAndCropId(cropId) {
		const apiReq = APISiteRequest.getProspectiveBuyersBySiteIdAndCropId(this.state.accessToken, this.state.siteId, cropId)
		apiReq.then((response) => {
			console.log('getProspectiveBuyersBySiteIdAndCropId', response, cropId)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const rows = []
			for(const v of response.results) {
				rows.push({id: v.mcs_prospective_buyer_id, name: v.target_market_name})
			}
			this.setState({registeredBuyers: rows})
		})
	}

	getAllCrops() {
		const types = APIFarmerRequest.getAllCrops(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name})
			}
			localStorage.setItem("crops", JSON.stringify(c))
			this.setState({crops: c})
		})
	}

	getAllUnitsOfMeasurement(callback) {
		const units = APIClusterRequest.getAllUnitsOfMeasurement(this.state.accessToken)
		units.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.measurement_id, name: (v.name).toUpperCase()})
			}
			this.setState({units: c})
		})
	}

	onMarketingButtonClicked(frm, delivery, targetCropId, itemId, clusterName, ciid) {
		if(delivery.delivery_id != null) {
			const dd = this.state.collectiveMarketing[itemId]
			if(dd != null) {
				const pd = {productDelivery: dd}
				this.editProductDeliverybyId(frm, dd.cluster_id, pd, dd.delivery_id, targetCropId, delivery, clusterName)
			}
			else {
				delivery['totalVolumeCommitted'] = parseInt(this.state.totalVolume.replace(/,/g, ""))
				this.props.setView(frm, delivery.cluster_id, clusterName, this.state.spid, targetCropId, delivery, ciid)
			}
			return
		}
		const collectiveMarketing = []
		const addCollectiveMarketing = []
		Object.values(this.state.collectiveMarketing).forEach((v => {
			v["supply_plan_id"] = this.state.spid
			if(v.delivery_id == null) {
				this.addProductDelivery(frm, v.cluster_id, v, targetCropId, delivery)
				return
			}
			else {
				collectiveMarketing.push(v)
			}
		}))
		const pdData = {}
		pdData["productDelivery "] = {
			"supply_plan_id": this.state.spid,
			"cluster_id": this.state.clusterId,
			"delivery_date": this.state.deliveryDate,
		}
	}
 
	setClusterNames(ics, disabled, clusterList, cropId, initialDates) {
		const clusters = []
		const itemObjCL = {}
		if(ics != null) {
			for(const v of ics) {
				const k = "cl-" + Math.random()
				itemObjCL[k] = <Cluster data={v} handler={this.eventHandlerCL} clusterList={clusterList}
					cropId={cropId} onClick={(itemId, frm, clusterId, targetCropId, clusterDD, ciid) => {
						this.props.setView(frm, clusterId, clusterDD.name, this.state.spid,
							targetCropId, clusterDD.deliveryDate, ciid)
					}}
					farmerCommitment={this.state.farmerCommitment}
					disabled={disabled} key={k} id={k} />
			}
			const k = "cl-" + Math.random()
			itemObjCL[k] = <Cluster handler={this.eventHandlerCL} clusterList={clusterList}
				cropId={cropId} onClick={(itemId, frm, clusterId, targetCropId, clusterDD) => {
					this.onSubmit(frm, clusterId, targetCropId, clusterDD)
				}}
				disabled={this.state.disabled} key={k} id={k} />
			Object.keys(itemObjCL).forEach((k => {
				clusters.push(itemObjCL[k])
			}))
		}
		else {
			const k = "cl-" + Math.random()
			itemObjCL[k] = <Cluster handler={this.eventHandlerCL} clusterList={clusterList}
				cropId={cropId} onClick={(itemId, frm, clusterId, targetCropId, clusterDD) => {
					if(this.state.spid == null) {
						this.onSubmit(frm, clusterId, targetCropId, clusterDD)
						return
					}
					this.props.setView(frm, clusterId, null, this.state.spid, targetCropId)
				}}
				disabled={disabled} key={k} id={k} />
			clusters.push(itemObjCL[k])
		}
		this.setState({clusters: clusters, itemObjCL: itemObjCL})
	}

	eventHandlerCL(e, compId, key, value) {
		switch(e) {
			case "cluster":
				this.state.clusterNames[compId] = value
				break
			case "marketing":
				this.state.collectiveMarketing[compId] = value
				break
			case "add":
				this.state.clusterNames[compId] = value
				const added = []
				const k = "cl-" + Math.random()
				const obj = this.state.itemObjCL.keys
				this.state.itemObjCL[k] = <Cluster handler={this.eventHandlerCL}
					clusterList={this.state.clusterList}
					onClick={(itemId, frm, clusterId, tcid, clusterDD) => {
						this.onSubmit(frm, clusterId, tcid, clusterDD)
					}}
					targetCropId={this.state.cropId} key={k} id={k} />
				Object.keys(this.state.itemObjCL).forEach((k => {
					added.push(this.state.itemObjCL[k])
				}))
				this.setState({clusters: added})
				break
			case "delete":
				this.state.deleteClusterNames[compId] = value
				this.state.deleteCollectiveMarketing[compId] = value
				delete this.state.collectiveMarketing[compId]
				delete this.state.clusterNames[compId]
				delete this.state.itemObjCL[compId]
				const deleted = []
				Object.keys(this.state.itemObjCL).forEach((k => {
					deleted.push(this.state.itemObjCL[k])
				}))
				this.setState({clusters: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('spf-scroll-area')
		const ca = document.getElementById('spf-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+60) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="supply-plan-form">
			<div id="spf-scroll-area"><div id="spf-client-area">
				<div id="spf-cell1">
					<div className="spf-cell1-row">
						<div id="spf-cell1-r1-i1">
							<div>* Crop Committed</div>
							<InputTextFilterWidget list={this.state.crops} placeholder={this.state.targetCrop} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.getAllClustersBySiteIdAndCropId((clusterList) => {
									}, id)
									this.getProspectiveBuyersBySiteIdAndCropId(id)
									this.setState({cropId: id})
								}} disabled={this.state.disabled} />
						</div>
						<div id="spf-cell1-r1-i2">
							<div>Total Volume Committed</div>
							<input type="text" placeholder='0' onChange={(e) => {
								this.setState({volume: e.target.value})
							}} disabled={true} value={`${this.state.totalVolume}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} />
						</div>
						<div id="spf-cell1-r1-i3">
							<div>* Unit of Measurement</div>
							<DropdownWidget list={this.state.units} placeholder={this.state.unit} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({unitId: id, unit: val})
								}} disabled={this.state.disabled} />
						</div>
						<div id="spf-cell1-r1-i3">
							<div>* Delivery Start Date</div>
							<DatePicker value={this.state.startDate} onChange={(value) => {
								this.setState({startDate: value})
							}} disabled={this.state.disabled} />
						</div>
						<div id="spf-cell1-r1-i3">
							<div>* Delivery End Date</div>
							<DatePicker value={this.state.endDate} onChange={(value) => {
								this.setState({endDate: value})
							}} disabled={this.state.disabled} />
						</div>
						<div id="spf-cell1-r1-i4">
							<div>* Name of Buyer</div>
							<DropdownWidget list={this.state.registeredBuyers} placeholder={this.state.buyer} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									if(this.state.targetBuyer == null) {
										this.state.targetBuyer = {}
									}
									this.state.targetBuyer['mcs_prospective_buyer_id'] = id
								}} disabled={this.state.disabled} />
						</div>
					</div>
				</div>
				<div className="title-bar">CLUSTERS</div>
				<div id="spf-cell2">
					<div>Note: Complete step 6 (Final Commitment Volume) to encode Collective Marketing</div>
				</div>
				<div id="spf-cell3">
					<div id="spf-cell3-r1">
						<div id="spf-cell3-left">
							<div id="spf-cell3-name">Cluster Name</div>
							<div id="spf-cell3-volume">Volume Committed </div>
							<div>Commitment Delivery Date</div>
						</div>
						<div className="spf-cell3-right">
							<div style={{width: '130px'}}>Actual Delivery Date</div>
							<div>Volume Sold</div>
						</div>
					</div>
					{this.state.clusters}
				</div>
			</div>
			{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				eventHandler={this.handleFooterEvent}
				showSubmit={(this.state.user.role_id == 3)? !this.state.disabled: false}
				showClose={this.state.disabled}
				showUpdate={this.state.disabled}/>}
			</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} eventHandler={this.handleFooterEvent}
					showSubmit={(this.state.user.role_id == 3)? !this.state.disabled: false}
					showClose={this.state.disabled}
					showUpdate={this.state.disabled}/></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class Cluster extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			clusterList: props.clusterList,
			targetCropId: props.cropId,
			clusterData: {},
			marketingData: {},
			cluster: "-- SELECT --",
			disableEncode: true,
			msg: false,
			disabledCM: true,
			datePickerDisabled: true,
			volumeSold: {},
			volumeCommitted: 0,
			totalDelivered: 0
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getAllTargetCropsByClusterId = this.getAllTargetCropsByClusterId.bind(this)
		this.getAllTargetCropByClusterIdAndCropId = this.getAllTargetCropByClusterIdAndCropId.bind(this)
		this.getProductDeliveryById = this.getProductDeliveryById.bind(this)
		this.editClusterTargetCropById = this.editClusterTargetCropById.bind(this)
		this.getClusterById = this.getClusterById.bind(this)
		this.getFarmerCommitmentsByClusterInvolvementId = this.getFarmerCommitmentsByClusterInvolvementId.bind(this)
	}

	componentWillMount() {
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.marketingData["cluster_id"] = this.props.data.cluster_id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.getClusterById(this.props.data.cluster_id)
			this.getFarmerCommitmentsByClusterInvolvementId(this.props.data.sp_involvement_id)
			this.getDeliveryDetailsByClusterInvolvementId(this.props.data.sp_involvement_id)
			this.setState({
				clusterId: this.props.data.cluster_id,
				spInvolvementId: this.props.data.sp_involvement_id,
				supplyPlanId: this.props.data.supply_plan_id,
				commitmentDate: this.props.data.commitment_date,
				deliveryDate: this.props.data.delivery_date,
				initialDate: this.props.data.commitment_date,
				targetCropId: this.props.data.target_crop_id,
				addDeleteButton: addDeleteButton,
				disabledCM: (this.props.data.sp_involved_cluster_id == null)? true: false,
				datePickerDisabled: false
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	componentDidUpdate(prevProps) {
	}

	getClusterById(clid) {
		const cluster = APIClusterRequest.getClusterById(this.state.accessToken, clid)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				clusterName: response.results.cluster.cluster_name.toUpperCase(),
			})
		})
	}

	getFarmerCommitmentsByClusterInvolvementId(spiid) {
		const apiReq = APISupplyPlanRequest.getFarmerCommitmentsByClusterInvolvementId(this.state.accessToken, spiid)
		apiReq.then((response) => {
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			let evalSupply = 0
			for(const v of response.results.farmerCommitment) {
				evalSupply += v.evaluated_supply
			}
			this.setState({
				volumeCommitted: evalSupply,
				disabledCM: (evalSupply > 0)? false: true
			})
		})
	}

	getDeliveryDetailsByClusterInvolvementId(spiid) {
		this.setState({showActivityIndicator: true})
		const apiReq = APISupplyPlanRequest.getDeliveryDetailsByClusterInvolvementId(this.state.accessToken, spiid)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			let totalDelivered = 0
			response.results.rows.map((item, i) => {
				totalDelivered += item.supply_delivered

			})
			this.setState({totalDelivered: `${totalDelivered}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")})
		})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.clusterData)
		this.setState({
			addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />,
			showButton: true
		})
	}
	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove cluster ${this.state.cluster}?`
		})
	}

	getAllTargetCropsByClusterId(id) {
		const req = APIClusterRequest.getAllTargetCropsByClusterId(this.state.accessToken, id)
		req.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.target_crop_id, name: formatDate(v.initial_commitment_date)})
			}
			this.setState({
				initialDates: c,
				msg: false
			})
		})
	}

	getAllTargetCropByClusterIdAndCropId(clid, crid) {
		const req = APIClusterRequest.getAllTargetCropByClusterIdAndCropId(this.state.accessToken, clid, crid)
		req.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					clusterId: clid,
					initialDates: [],
					msg: false
				})
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.target_crop_id, name: formatDate(v.initial_commitment_date)})
			}
			this.setState({
				clusterId: clid,
				targetCropId: c.id,
				initialDates: c,
				msg: false
			})
		})
	}

	getProductDeliveryById(id) {
		const apiReq = APISupplyPlanRequest.getProductDeliveryById(this.state.accessToken, id)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.getClusterById(true)
				return
			}
			let totalSD = 0
			response.results.deliveryDetail.map((item, i) => {
				totalSD += item.supply_delivered
			})
			this.state.volumeSold[response.results.productDelivery.delivery_id] = totalSD
		})
	}

	editClusterTargetCropById(targetCrop) {
		const apiReq = APIClusterRequest.editClusterTargetCropById(this.state.accessToken, targetCrop, this.state.targetCropId)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
				targetCrops: {}
			})
		})
	}

	editSupplyPlan(data) {
		const apiReq = APISupplyPlanRequest.editSupplyPlanById(this.state.accessToken, data, this.state.supplyPlanId)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showActivityIndicator: false
				})
				return
			}
			this.props.onClick(this.state.itemId, "collective-marketing", this.state.clusterId, this.state.targetCropId, this.state.cluster.toUpperCase(), this.state.marketingData)
		})
	}

	render() {
		const view = <div className="cluster-name">
			<div>{this.state.addDeleteButton}</div>
			<div className="cn-rows">
			<div className="spf-cell3-left">
				<div>
					<DropdownWidget list={this.state.clusterList} placeholder={this.state.clusterName}
						cStyle={{"width": '170px'}} onItemSelected={(id, val) => {
							const list = Object.values(this.state.clusterList)
							let tcid
							list.map((item, i) => {
								if(item.id == id) {
									tcid = item.targetCropId
								}
							})
							this.state.clusterData["cluster_id"] = id
							this.props.handler("cluster", this.state.itemId, null, this.state.clusterData)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.getAllTargetCropByClusterIdAndCropId(id, this.state.cropId)
							this.setState({
								cluster: val,
								clusterId: id,
								datePickerDisabled: false,
								targetCropId: tcid,
								clusterName: val
							})
						}} disabled={this.state.disabled} />
				</div>
				<div style={{'padding-top': '5px', width: '110px'}}>
					<input id='committed' value={`${this.state.volumeCommitted}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} disabled />
				</div>
				<div style={{'padding-top': '5px', width: '130px'}}>
					<DatePicker value={this.state.initialDate} onChange={(value) => {
						const targetCrop = {clusterTargetCrop: {
							target_crop_id: this.state.targetCropId,
							cluster_id: this.state.clusterId,
							commitment_date: value,
							crop_id: this.state.cropId,
						}}
						this.editClusterTargetCropById(targetCrop)
						this.state.clusterData["commitment_date"] = value
						this.props.handler("cluster", this.state.itemId, null, this.state.clusterData)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.setState({initialDate: value})
					}} disabled={this.state.datePickerDisabled} />
				</div>
				<div>
					<button className="cn-buttons" onClick={(e) => {
						if(this.state.clusterId == null || this.state.initialDate == null) {
							this.setState({msg: true})
							return
						}
						const clusterDD = {
							name: this.state.clusterName,
							deliveryDate: this.state.initialDate,
							ciid: this.state.spInvolvementId
						}
						console.log('clusterDD', clusterDD)
						this.props.onClick(this.state.itemId, "encode-commitments", this.state.clusterId, this.state.targetCropId, clusterDD, this.state.spInvolvementId)
					}} >ENCODE COMMITMENTS</button>
					{this.state.msg && <div className="cn-msg">* Select cluster name and delivery date</div>}
				</div>
			</div>
			<div className="spf-cell3-right">
				<DatePicker value={this.state.deliveryDate} onChange={(value) => {
					this.state.clusterData["delivery_date"] = value
					this.setState({
						deliveryDate: value,
						clusterData: {involvedCluster: [{
							sp_involvement_id: this.state.spInvolvementId,
							supply_plan_id: this.state.supplyPlanId,
							cluster_id: this.state.clusterId,
							commitment_date: this.state.commitmentDate,
							delivery_date: value
						}]}
					})
				}} disabled={this.state.disabledCM} />
				<div style={{width: '110px'}}>
					<input id='sold' value={this.state.totalDelivered} disabled/>
				</div>
				<div>
					{this.state.disabledCM && <button className="cn-buttons btn-mkt" disabled={this.state.disabledCM}>ENCODE COLLECTIVE MARKETING</button>}
					{!this.state.disabledCM && <button className="cn-buttons btn-mkt-en" onClick={(e) => {
						if(this.state.deliveryDate == null) {
							this.setState({ddMSG: true})
							return
						}
						this.state.marketingData["totalVolumeSold"] = this.state.volumeSold
						if(this.state.deliveryDate != this.props.data.delivery_date) {
							this.editSupplyPlan(this.state.clusterData)
						}
						const clusterDD = {
							name: this.state.clusterName.toUpperCase()
						}
						this.props.onClick(this.state.itemId, "collective-marketing", this.state.clusterId, this.state.targetCropId, clusterDD, this.state.spInvolvementId)
					}}>ENCODE COLLECTIVE MARKETING</button>}
					{this.state.ddMSG && <div className="cm-msg">* Select delivery date</div>}
				</div>
			</div>
			</div>
			{this.state.showConfirmChangeDate == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmChangeDate: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.onClick(this.state.itemId, "collective-marketing", this.state.clusterId, this.state.targetCropId, this.state.marketingData)
				}
			}} />}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.handler("delete", this.state.itemId, null, this.state.clusterData)
				}
			}} />}
		</div>
		return(view)
	}
}

const formatDate = (value) => {
	const dt = new Date(value)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m} / ${d} / ${dt.getFullYear()}`
	return(dFormat)
}

export default SupplyPlan
